import LoadingIndicator from '@static/images/icons/loading-indicator.svg';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './LoadingView.module.scss';

interface LoadingViewProps {
  loading?: boolean;
  className?: string;
  children?: ReactNode;
}

export const LoadingView = ({
  loading,
  children,
  className,
}: LoadingViewProps) =>
  loading ? (
    <div
      data-testid="loading-view"
      className={clsx(styles.container, className)}
    >
      <LoadingIndicator className={styles.indicator} />
    </div>
  ) : (
    <>{children}</>
  );
